import { defineMessages } from "react-intl";

const messages = defineMessages({
    back: {
        id: "general.back",
    },
    loading: {
        id: "general.loading",
    },
    unknown: {
        id: "general.unknown",
    },
    notFound: {
        id: "error.404.title",
    },
});

export default messages;
